export const RSS_STATUS_TYPES = {
  FOUND_RSS_FEEDS: 'FOUND_RSS_FEEDS',
  NO_FEEDS_FOUND: 'NO_FEEDS_FOUND',
  TIMEOUT: 'TIMEOUT',
  INVALID_URL: 'INVALID_URL',
  VALIDATOR_ERROR: 'VALIDATOR_ERROR',
  HTTP_RETRIEVAL_ERROR: 'HTTP_RETRIEVAL_ERROR',
  NO_GUID_OR_LINK: 'NO_GUID_OR_LINK',
  NO_GENERATED_GUID: 'NO_GENERATED_GUID',
  FEED_EMPTY: 'FEED_EMPTY',
  FEED_OK: 'FEED_OK'
};
export const VALID_RSS_STATUS_TYPES = [RSS_STATUS_TYPES.NO_GUID_OR_LINK, RSS_STATUS_TYPES.FEED_EMPTY, RSS_STATUS_TYPES.FEED_OK];
export const WARNING_RSS_STATUS_TYPES = [RSS_STATUS_TYPES.NO_GUID_OR_LINK, RSS_STATUS_TYPES.FEED_EMPTY];